let tipoIncidencias = Object.freeze({
    list: [ 
        { value: '1', text: 'Horas Ordinarias', name: "horas_ordinarias" },
        { value: '2', text: 'Horas Retardo', name: "horas_retardo" },
        { value: '3', text: 'Horas Adicionales', name: "horas_adicionales" },
        { value: '4', text: 'Horas Domingo', name: "horas_domingo" },
        { value: '5', text: 'Horas Extras Dobles', name: "horas_extras_dobles" },
        { value: '6', text: 'Horas Extras Triples', name: "horas_extras_triples" },
        { value: '7', text: 'Horas Festivo Trab.', name: "horas_festivo_trab" },
        { value: '8', text: 'Horas Descanso Trab.', name: "horas_descanso_trab" },
        { value: '9', text: 'Horas Vacaciones Trab.', name: "horas_vacaciones_trab" },
        { value: '10', text: 'Horas Permiso c/Goce', name: "horas_permiso_c_goce" },
        { value: '11', text: 'Horas Permiso s/Goce', name: "horas_permiso_s_goce" },
        { value: '12', text: 'Días Falta Injustificada', name: "dias_falta_injustificada" },
        { value: '13', text: 'Días Vacaciones', name: "dias_vacaciones" },
        { value: '14', text: 'Días Aguinaldo', name: "dias_aguinaldo" },
        { value: '15', text: 'Días Asistencia', name: "dias_asistencia" },
        { value: '16', text: 'Días Retardo', name: "dias_retardo" },
        { value: '17', text: 'Días IMSS', name: "dias_imss" },
        { value: '18', text: 'Días EyM', name: "dias_eym" },
        { value: '19', text: 'Días Ajuste', name: "dias_ajuste" },
        { value: '20', text: 'Horas Extras', name: "horas_extras" },
        { value: '21', text: 'Días Ordinario', name: "dias_ordinario" },
    ]
});

module.exports = { tipoIncidencias }